const data = {
  title: "Druphelp.care",
  news: "Noticias",
  contact: "Contáctenos",
  itemsperpage: "Elementos por página",
  copyrightFooter: "Derechos de autor©️2020 drughelp.care, Todos los derechos reservados.",
  back: "Atrás",
  open: "Abrir",
  privacypolicy: "Política de privacidad",
  closed: "Cerrar",
  showingservices: "Mostrando {available} servicios {count} disponibles",
  termsandconditions: "Términos y condiciones",
  welcome: "Bienvenido",
  findthesubstanceusetreatmentyouneed: "Encuentre el tratamiento para el abuso de sustancias que necesita",
  spanish: "Español",
  prev: "Anterior",
  next: "Próximo",
  createNew: "Crear nuevo",
  service: "Servicio",
  services: "Servicio",
  agency: "Agencia",
  agencies: "Agencias",
  home: "Inicio",
  about: "Acerca de",
  menu: "Menú ",
  faq: "Preguntas Frecuentes",
  events: "Eventos",
  adminLogin: "Inicio de Sesión de Administrador",
  sortBy: "Ordenar Por",
  recentlyUpdated: "Recientemente Actualizado",
  agencyNameAtoZ: "Nombre de la Agencia (A a Z)",
  agencyNameZtoA: "Nombre de la Agencia (Z a A)",
  distanceFromYou: "Distancia desde Tu Ubicación",
  distanceFromYourZipCode: "Distancia desde Tu Código Postal",
  walkInsOnly: "Solo Personas sin Cita",
  spanishLanguageServicesFirst: "Servicios en Español Primero",
  updated: "actualizado",
  slotsAreAvailable: "hay cupos disponibles",
  slotIsAvailable: "hay un cupo disponible",
  user: "Usuario",
  users: "Usuarios",
  category: "Categoría",
  categories: "Categorías",
  hotline: "Línea Director",
  hotlines: "Líneas Directas",
  hotlinecategories: "Categorías de línea directa",
  feature: "Función",
  features: "Funciones",
  timeInfo: "Información sobre el tiempo",
  timeInfos: "Informaciones sobre el tiempo",
  search: "Buscar",
  changePassword: "Cambiar Contraseña",
  routes: {
    dashboard: "Panel de control",
    login: "Iniciar Sesión",
    availabilityStatus: "Estado de disponibilidad"
  },
  view: {
    services: {
      search: "Buscar",
      searchServices: "Buscar Servicios",
      searchResult: '"{count} Resultado encontrado "{term}"',
      openWebSite: "Abrir sitio web",
      call: "Llamar",
      searchError: "Ocurrió un error al buscar servicios",
      noResultsFound:
        "No se encontraron resultados coincidentes para la búsqueda dada",
      noServicesAvailable: "No hay servicios disponibles en este momento",
      viewService: "Ver Servicio",
      unregisteredService:
        "Este servicio de tratamiento no está registrado o no se ha actualizado en más de un año.",
      walkInsWelcome: "Se Aceptan Personas sin Cita"
    },
    categories: {
      search: "Buscar",
      searchCategories: "Buscar Categorías",
      searchResult: "Resultado(s) encontrado(s) para",
      openWebSite: "Abrir Sito Web",
      searchError: "Ocurrió un error al buscar servicios",
      noResultsFound:
        "No se encontraron resultados coincidentes para la búsqueda dada",
      noCategoriesAvailable: "No hay categorías disponibles en este momento",
      viewCategory: "Ver Categoría",
      editCategory: "Editar categoría",
      addCategory: "Añadir nueva categoría"
    },
    agencies: {
      search: "Buscar",
      searchAgencies: "Buscar Agencias",
      searchResult: "Resultado(s) encontrado(s) para",
      openWebSite: "Abrir Sito Web",
      searchError: "Ocurrió un error al buscar agencias",
      noResultsFound:
        "No se encontraron resultados coincidentes para la búsqueda dada",
      noAgenciesAvailable: "No hay agencias disponibles en este momento",
      viewAgency: "Ver agencia",
      editAgency: "Editar agencia",
      addAgency: "Añadir nueva agencia"
    },
    hotlines: {
      search: "Buscar",
      searchHotlines: "Buscar líneas de ayuda",
      searchResult: '{count} Resultados) encontrado(s) para"{term}"',
      searchError: "Ocurrió un error al buscar líneas de ayuda",
      viewHotline: "Ver línea de ayuda",
      editHotline: "Editar línea de ayuda",
      addHotline: "Añadir nueva línea de ayuda",
      noResultsFound:
        "No se encontraron resultados coincidentes para la búsqueda dada",
      noHotlinesAvailable: "No hay líneas de ayuda disponibles en este momento"
    },
    hotlinecategories: {
      Error: "Ocurrió un error al cargar la página"
    },
    users: {
      search: "Buscar",
      searchUsers: "Buscar usuarios",
      searchResult: '{count} Resultado encontrado"{term}"',
      openWebSite: "Abrí Sito Web",
      searchError: "Ocurrió un error al buscar usuarios",
      noResultsFound:
        "No se encontraron resultados coincidentes para la búsqueda dada",
      noUsersAvailable: "No hay usuarios disponibles en este momento",
      viewUser: "Ver usuario",
      editUser: "Editar usuario",
      addUser: "Añadir nuevo usuario"
    },
    categoryEdit: {
      categoryNotFound: "Categoría no encontrada"
    },
    features: {
      search: "Buscar",
      searchFeatures: "Buscar características",
      searchResult: "Resultado(s) encontrado(s) para",
      openWebSite: "Abrir sitio web",
      searchError: "Ocurrió un error al buscar características",
      noResultsFound:
        "No se encontraron resultados coincidentes para la búsqueda dada",
      noFeaturesAvailable: "No hay características disponibles en este momento",
      viewFeature: "Ver característica",
      editFeature: "Editar característica"
    },
    searchService: {
      searchServices: "Buscar por nombre de agencia/nombre de servicio",
      search: "Buscar",
      downloadResults: "Descargar Resultados"
    },
    filterOptions: {
      assessment:
        "Una entrevista amigable que es el primer paso para obtener ayuda",
      outpatient: "Consejería individual o grupal",
      intensiveoutpatientprogram: "Consejería grupal varios días a la semana",
      partialhospitalization:
        "Tratamiento diurno para aquellos con necesidades más altas",
      residential: "Duermes aquí y recibes tratamiento durante el día",
      inpatient:
        "Como un hospital para aquellos que requieren monitoreo médico las 24 horas del día, los 7 días de la semana",
      recoveryhousingsoberliving: "Un lugar sobrio y de apoyo para vivir",
      peersupportrecovery: "Apoyo entre pares/Recuperación",
      communityadvocates: "Defensores comunitarios",
      recoverymeetingsgroups: "Reuniones/Grupos De recuperación",
      familysupportgroups: "Grupos de apoyo para familias",
      hivhepatitistesting: "Pruebas de VIH/hepatitis",
      obtainingnarcan: "Obtener Narcan",
      needleexchange: "Intercambio de agujas",
      drugeducation: "Educación sobre drogas",
      pregnancyprevention: "Prevención del embarazo",
      fentanyltestingstrips: "Pruebas de ventanillo",
      unuseddrugdisposal: "Eliminación de medicamentos no utilizados"
    },
    defaultText: {
      default: "Contenido predeterminado"
    },
    mainPage: {
      quickSearchHeading: "Búsqueda Rápida",
      quickSearchSubHeading:
        "Responde algunas preguntas para encontrar servicios de tratamiento",
      advancedSearchHeading: "Búsqueda Avanzada",
      advancedSearchSubHeading:
        "Utiliza más de 100 filtros para encontrar servicios de tratamiento"
    },
    otherResources: {
      otherresources: "Otros recursos",
      harmreductionbutton: "REDUCCIÓN DE DAÑOS",
      harmreduction:
        "Recursos para mantenerse vivo y mejorar la salud personal y comunitaria",
      freenaloxonebutton: "Naloxona Gratuita",
      freenaloxone: "Obtener naloxona gratuita",
      peerandfamilysupportbutton: "APOYO PARA PARES Y FAMILIAS",
      peerandfamilysupport:
        "Servicios para aquellos en recuperación y sus familias",
      crisishotlinebutton: "LÍNEAS DE CRISIS",
      crisishotlinedefault: "Access crisis hotlines",
      crisishotlinecount: "Acceder a {count} líneas de crisis"
    },
    categoryNames: {
      harmreduction: "Reducción de Daños",
      treatmentservices: "Servicios de Tratamiento",
      peerandfamilysupport: "Apoyo de Pares y Familiar",
      crisishotlines: "Líneas de Ayuda en Crisis"
    },
    filterYourResults: {
      treatmentservices: {
        loading: "Cargando...",
        treatmentservices: "Servicios de Tratamiento",
        assessment: "Evaluación",
        inpatient: "Hospitalización",
        intensiveoutpatientprogram: "Programa Intensivo Ambulatorio",
        outpatient: "Ambulatorio",
        partialhospitalization: "Hospitalización Parcial",
        recoveryhousingsoberliving: "Vivienda de Recuperación/Vivienda Seca",
        residential: "Residencial"
      },
      telehealthservices: {
        telehealthservices: "Servicios de Telesalud",
        telehealthavailable: "Telemedicina Disponible"
      },
      eligibilitycriteria: {
        eligibilitycriteria: "Criterios de Elegibilidad",
        genderanygender: "Género - Cualquier Género",
        gendermalesonly: "Género - Solo Hombres",
        genderfemalesonly: "Género - Solo Mujeres",
        pregnantfemalesaccepted: "Se Aceptan Mujeres Embarazadas",
        agenominors: "Edad - Sin Menores",
        ageonlyminors: "Edad - Solo Menores",
        ageminorsaccepted: "Edad - Se Aceptan Menores",
        sexoffendersaccepted: "Se Aceptan Delincuentes Sexuales",
        nosexoffenders: "No Se Aceptan Delincuentes Sexuales",
        arsonistsaccepted: "Se Aceptan Incendiarios",
        noarsonists: "No Se Aceptan Incendiarios",
        criminaljusticeclientsonly: "Clientes de Justicia Penal",
        criminaljusticeclientsaccepted:
          "Solo Se Aceptan Clientes de Justicia Penal",
        childprotectiveservicesclientsaccepted:
          "Se Aceptan Clientes de Servicios de Protección Infantil"
      },
      focusesandaccommodations: {
        focusesandaccommodations: "Enfoques y Adaptaciones",
        transgenderaccommodated: "Se Acomoda a Personas Transgénero",
        veteransfocused: "Enfocado en Veteranos",
        lgbtqfocused: "Enfocado en LGBTQ",
        lgbtqfriendly: "Amigable con LGBTQ",
        autismspectrumdisorderasdfriendly:
          "Amigable con Trastorno del Espectro Autista (TEA)",
        nosmoking: "No Fumar",
        smokingallowed: "Se Permite Fumar",
        accompanyingminorsallowed:
          "Se Permite la Entrada de Menores Acompañados"
      },
      insuranceaccepted: {
        insuranceaccepted: "Seguros Aceptados",
        veteransadministrationvabenefits:
          "Beneficios de la Administración de Veteranos (VA)",
        medicaid: "Medicaid",
        medicare: "Medicare",
        privateinsurance: "Seguro Privado",
        selfpay: "Pago por Cuenta Propia",
        criminaljusticecourtreferral: "Derivación de Justicia Penal/Tribunal",
        uninsured: "Sin Seguro"
      },
      mentalhealthconcerns: {
        mentalhealthconcerns: "Problemas de Salud Mental",
        anxiety: "Ansiedad",
        depression: "Depresión",
        posttraumaticstressdisorderptsd:
          "Trastorno de Estrés Postraumático (TEPT)",
        attentiondeficithyperactivitydisorderadhd:
          "Trastorno por Déficit de Atención e Hiperactividad (TDAH)",
        bipolardisorder: "Trastorno Bipolar",
        personalitydisordersborderlineantisocialetc:
          "Trastornos de la Personalidad (Límite, Antisocial, etc.)",
        obsessivecompulsivedisorderocd: "Trastorno Obsesivo-Compulsivo (TOC)",
        schizophreniapsychoticdisorders:
          "Esquizofrenia y Trastornos Psicóticos",
        eatingdisorders: "Trastornos de la Alimentación"
      },
      interventionsused: {
        interventionsused: "Intervenciones Utilizadas",
        cognitivebehavioraltherapy: "Terapia Cognitivo-Conductual",
        motivationalinterviewing: "Entrevista Motivacional",
        "12stepprogram": "Programa de 12 Pasos",
        harmreduction: "Reducción de Daños",
        traumafocusedcounseling: "Consejería Enfocada en el Trauma",
        dialecticalbehaviortherapy: "Terapia Dialéctica Conductual",
        interactivejournaling: "Diario Interactivo",
        solutionfocused: "Enfoque en Soluciones",
        psychoeducation: "Psicoeducación",
        contingencymanagementtherapy: "Terapia de Manejo de Contingencias"
      },
      matsuboxone: {
        matsuboxone: "TAM - Suboxone",
        provideorprescribe: "Proveer o Recetar",
        allowbutdonotprovide: "Permitir pero no Proveer",
        donotallow: "No Permitir"
      },
      matsublocadeinjection: {
        matsublocadeinjection: "TAM - Inyección Sublocade",
        provideorprescribe: "Proveer o Recetar",
        allowbutdonotprovide: "Permitir pero no Proveer",
        donotallow: "No Permitir"
      },
      matmethadone: {
        matmethadone: "TAM - Metadona",
        provideorprescribe: "Proveer o Recetar",
        allowbutdonotprovide: "Permitir pero no Proveer",
        donotallow: "No Permitir"
      },
      matvivitrol: {
        matvivitrol: "TAM - Vivitrol",
        provideorprescribe: "Proveer o Recetar",
        allowbutdonotprovide: "Permitir pero no Proveer",
        donotallow: "No Permitir"
      },
      matcampral: {
        matcampral: "TAM - Campral",
        provideorprescribe: "Proveer o Recetar",
        allowbutdonotprovide: "Permitir pero no Proveer",
        donotallow: "No Permitir"
      },
      matantabuse: {
        matantabuse: "TAM - Antabuse",
        provideorprescribe: "Proveer o Recetar",
        allowbutdonotprovide: "Permitir pero no Proveer",
        donotallow: "No Permitir"
      },
      additionalservicesonsite: {
        additionalservicesonsite: "Servicios Adicionales en el Sitio",
        applyingformedicaid: "Solicitud para Medicaid",
        birthcontrol: "Anticonceptivos",
        casemanagement: "Gestión de Casos",
        childcare: "Cuidado Infantil",
        compassionateprenatalcare: "Atención Prenatal Compasiva",
        eapcounseling: "Consejería EAP",
        employmenttraining: "Capacitación Laboral",
        familysupportclasses: "Clases de Apoyo Familiar",
        hivhepatitistesting: "Pruebas de VIH/Hepatitis",
        housingassistance: "Asistencia para la Vivienda",
        legalassistance: "Asistencia Legal",
        needleexchange: "Intercambio de Agujas",
        obtainingged: "Obtención de GED",
        obtainingid: "Obtención de Identificación",
        obtainingnarcan: "Obtención de Narcan",
        peerrecovery: "Recuperación entre Pares",
        recoverymeetings: "Reuniones de Recuperación",
        primarycaredoctor: "Médico de Atención Primaria",
        smokingcessation: "Abandono del Tabaco",
        transportationassistance: "Asistencia de Transporte",
        serviceprovidedathome: "Servicio Proporcionado en Casa",
        serviceprovidedathospital: "Servicio Proporcionado en el Hospital",
        serviceprovidedatjail: "Servicio Proporcionado en la Cárcel",
        asllanguageassistance: "Asistencia en Lenguaje de Señas Americano",
        spanishlanguageassistance: "Asistencia en Español",
        chineselanguageassistance: "Asistencia en Chino",
        computertranslationinterpretationservice:
          "Servicio de Traducción/Interpretación por Computadora"
      },
      walkinswelcome: {
        walkinswelcome: "Se Aceptan Personas sin Cita",
        yes: "sí",
        no: "no"
      }
    },
    servicePage: {
      slotavailability: "Disponibilidad de espacios",
      open: {
        servicehours: "Horario de servicio",
        walkinhours: "Horario de atención sin cita",
        intakehours: "Horario de admisión"
      },
      agencydescription: "Descripción de la agencia",
      servicedescription: "Descripción del servicio",
      additionalinformationandcriteria: "Información adicional y criterios",
      provideorprescribe: "Proveer o Recetar",
      allowbutdonotprovide: "Permitir pero no Proveer",
      donotallow: "No Permitir"
    },
    privacypolicy: {
      privacypolicy: "Política de privacidad",
      thisprivacypolicyiseffectiveforallusers: {
        title:
          "Esta Política de Privacidad es vigente para todos los usuarios.",
        description:
          "Gracias por visitar <i>drughelp.care</i>, un sitio web diseñado para mejorar el acceso al tratamiento para el uso de sustancias. En concordancia con las disposiciones de la Ley de Seguridad y Privacidad en Internet, la Ley de Libertad de Información y la Ley de Protección de Privacidad Personal, esta política describe las prácticas de privacidad de drughelp.care con respecto a la información recopilada de los usuarios de este sitio web. Esta política detalla qué información se recopila y cómo se utiliza dicha información.<br><br> Los términos “nosotros”, “nos” y “<i>drughelp.care</i>” se refieren a <i>drughelp.care</i>, un sitio web desarrollado por investigadores de la Universidad Estatal de Cleveland en Cleveland, Ohio. Al usar este sitio, usted consiente la recopilación, el uso y la divulgación de su información según lo descrito en esta Política de Privacidad."
      },
      informationcollectedautomaticallywhenyouvisitthiswebsiteandhowweuseit: {
        title:
          "Información recopilada automáticamente cuando visita este sitio web y cómo la utilizamos",
        description:
          "Podemos recopilar y almacenar información sobre usted en relación con su uso del sitio. Utilizaremos la dirección IP de su computadora para diferenciarlo de otros usuarios. Recopilaremos información sobre los filtros de búsqueda, las opciones de ordenamiento y los términos de búsqueda que utilice. Usaremos esta información para personalizar lo que ve en el sitio web en función de su historial de uso, permitiéndole acceder más rápidamente a la información que necesita."
      },
      accesstoyourlocation: {
        title: "Acceso a su ubicación",
        description:
          "Tiene la opción de activar los servicios de ubicación para permitirnos brindarle una mejor asistencia. No recopilamos información sobre su ubicación automáticamente. Debe autorizarnos a acceder a su ubicación para utilizar ciertas funciones de este sitio web, como encontrar servicios cercanos. Sin embargo, el resto de la información en este sitio web funciona completamente sin permitirnos acceder a su ubicación."
      },
      informationcollectedwhenyoucreateanagencyaccount: {
        title: "Información recopilada cuando crea una cuenta de agencia",
        description:
          "Si crea una cuenta de agencia en <i>drughelp.care</i>, podemos almacenar y utilizar la información que proporcione durante ese proceso, como su nombre completo, dirección de correo electrónico, nombre de la agencia, dirección de la agencia y número de teléfono. Podemos mostrar públicamente el nombre de su agencia, así como cualquier otro contenido que envíe durante el proceso de registro, como parte del perfil de su cuenta de agencia. Su dirección de correo electrónico y número de teléfono pueden ser utilizados para contactarlo. Si cree que alguien ha creado una cuenta no autorizada en representación de su agencia, puede solicitar su eliminación contactándonos en <a href='mailto:admin@drughelp.care' style='color:#3d97d3'><strong>admin@drughelp.care</strong></a>."
      },
      cookies: {
        title: "Cookies",
        description:
          "Las cookies se utilizan para distinguir entre los usuarios de este sitio web. Esta es una práctica estándar entre los sitios web de Internet. Las cookies pueden tener identificadores únicos y residir en su computadora, dispositivo móvil, en correos electrónicos que le enviamos, en nuestras páginas web u otros lugares. Este sitio web utiliza cookies para almacenar información sobre su uso del sitio, incluido su historial de filtros de búsqueda, opciones de ordenamiento o términos que utiliza para buscar en nuestro sitio web."
      },
      informationcollectedwhenyouemailus: {
        title: "Información recopilada cuando nos envía un correo electrónico",
        description:
          "Durante su visita a este sitio web, puede enviar un correo electrónico a <i>drughelp.care</i>. Se recopilarán su dirección de correo electrónico y el contenido de su mensaje. La información recopilada incluye texto, audio, video y formatos de información gráfica incluidos en el mensaje. Su dirección de correo electrónico y la información contenida en su mensaje se utilizarán para responderle, abordar los problemas que identifique y mejorar este sitio web."
      },
      security: {
        title: "Seguridad",
        description:
          "Utilizamos diversas medidas de protección para resguardar la información personal que nos envía, tanto durante la transmisión como al recibirla. Sin embargo, ningún método de transmisión a través de Internet o dispositivos móviles es 100% seguro. Por lo tanto, nos esforzaremos por proteger su información personal, pero no podemos garantizar su seguridad absoluta."
      },
      contact: {
        title: "Contacto",
        description:
          "Por favor, <a href='mailto:admin@drughelp.care' style='color:#3d97d3'><strong>contáctenos</strong></a> si tiene alguna pregunta o inquietud sobre nuestra Política de Privacidad."
      }
    },
    quickSearchQuestions: {
      note:
        "Drughelp.care no guarda tu historial de búsqueda.Tus respuestas a estas preguntas solo se usarán para conectarte con los mejores servicios de tratamiento.",
      q1: {
        question: "¿Tiene usted 18 años o más?",
        yes: "sí",
        no: "no"
      },
      q2: {
        question: "¿Cuál es su género?",
        female: "Mujer",
        male: "Hombre",
        other: "Otro/Otra Identidad"
      },
      q3: {
        question: "¿Estás embarazada?",
        yes: "sí",
        no: "no"
      },
      q4: {
        question: "¿Has sido veterano o veterana?",
        yes: "sí",
        no: "no",
        familymemberofaveteranmilitaryservicemember:
          "Familiar de un veterano o militar",
        idontknow: "Prefiero no responder"
      },
      q5: {
        question: "¿Qué tipo de seguro médico tienes?",
        noinsurance: "No tengo seguro",
        medicare:
          "Medicare/ Seguro médico del gobierno para personas con discapacidad",
        medicaid: "Medicaid -Seguro médico para personas con bajos ingresos",
        privateinsurance: "Seguro privado",
        vainsurance: "Seguro de Veteranos /VA",
        courtordered: "Seguro Ordenado por la corte",
        idontknow: "Prefiero no responder"
      },
      q6: {
        question: "¿Padece usted de alguno de estos?",
        subQ: "(Puedes elegir más de uno)",
        anxietydepression: "Anxiedad/Depresión",
        bipolardisorder: "Desorden Bipolar",
        personalitydisorders: "Trastornos de personalidad",
        obsessivecompulsivedisorderocd: "Trastorno Obsesivo Compulsivo (TOC)",
        schizophrenia: "Esquizofrenia",
        eatingdisorders: "Trastornos Alimenticios",
        ptsd: "Estrés postraumático /TEPT",
        adhd: "Déficit de atención e hiperactividad /TDAH",
        noneidontknow: "Ninguno/No sé"
      },
      q7: {
        question: "¿Qué droga usas?",
        subQ: "(Puedes elegir más de uno)",
        heroinpainpillsfentanylandorotheropioids:
          "Heroína, Pastillas para el dolor, Fentanilo y/o otros opioides",
        alcohol: "Bebidas Alcohólicas",
        benzosvaliumxanaxativan:
          "Medicamentos para la ansiedad Benzos,Valium,Xanax,Ativan",
        marijuana: "Marihuana",
        cocaineandormeth: "Cocaína /Coca y/o meta/cristal",
        otheridontknow: "Otro / No estoy seguro/a"
      },
      q8: {
        question: "¿Necesitas transporte a tu cita?",
        yes: "sí",
        no: "no"
      }
    },
    termsandconditions: {
      termsandconditionsofuse: {
        title: "Términos y condiciones de uso",
        description:
          "Bienvenidos a <i>drughelp.care</i>.Nuestro objetivo es facilitar el acceso al tratamiento para el uso de sustancias,permitiendo que las personas y los proveedores de tratamiento encuentren más rápido los servicios y tratamientos.<br><br> Estos términos y condiciones describen las reglas y normas para el uso de el sito web de <i>drughelp.care</i>'s.<i>drughelp.care</i> es un sitio web desarrollado por investigadores de Cleveland State University en Cleveland, Ohio, Estados Unidos. Al acceder a este sitio web, asumimos que aceptas todos estos términos y condiciones. No continúes usando el sitio web de <i>drughelp.care</i> si no aceptas todos los términos y condiciones que se indican en esta página."
      },
      thefollowingterminology: {
        title:
          "La siguiente terminología se aplica a estos Términos y Condiciones, Declaración de Privacidad, Aviso de Renuncia y a cualquiera o a todos los Acuerdos",
        description:
          '"Cliente","Tú" y "Tu" se refieren a ti, la persona que accede a este sitio web y acepta los términos y condiciones de la Compañía. "La Compañía", "Nosotros","Nuestro" y "Nos" se refieren a nuestra Compañía. "Parte","Partes" o "Nosotros" se refieren tanto al Cliente como a nosotros, o a cualquiera de los dos. Todos los términos se refieren a la oferta, aceptación y consideración del pago necesario para llevar a cabo nuestro apoyo al Cliente de la manera más adecuada, ya sea mediante reuniones formales de duración fija o cualquier otro medio, con el propósito expreso de satisfacer las necesidades del Cliente en cuanto a la prestación de los servicios/productos de la Compañía, de acuerdo con la ley vigente.\nCualquier uso de la terminología anterior, o de otras palabras en singular, plural, mayúsculas y/o él/ella o ellos, se entiende como intercambiable y por lo tanto se refiere a lo mismo.'
      },
      cookies: {
        title: "este sitio web utiliza cookies",
        description:
          "Usamos cookies. Al usar el sitio web<i>drughelp.care</i>, aceptas el uso de cookies según nuestra política de privacidad de <i>drughelp.care</i>. La mayoría de los sitios web modernos usan cookies para recordar información de los visitantes. Usamos cookies en algunas partes del sitio para que funcionen bien y sean más fáciles de usar."
      },
      license: {
        title: "licencia",
        description:
          "A menos que se indique lo contrario, <i>drughelp.care</i> y/o sus licenciantes son los titulares de los derechos de propiedad intelectual sobre todo el material presente en <i>drughelp.care</i>. Todos los derechos de propiedad intelectual están reservados. Usted puede visualizar y/o imprimir páginas de http://drughelp.care/ para su uso personal, sujeto a las restricciones establecidas en estos términos y condiciones.",
        youmustnot: {
          title: "No debes",
          bullets: [
            "Reproducir o publicar nuevamente material de http://drughelp.care/",
            "Vender,rentar o sub-licenciar material de http://drughelp.care/",
            "Reproducir, duplicar o copiar material de http://drughelp.care/",
            "Redistribuir contenido de <i>drughelp.care</i> (a menos que el contenido esté específicamente hecho para redistribuirse)"
          ]
        }
      },
      hyperlinkingtoourcontent: {
        title: "Crear enlaces a nuestro contenido",
        bullets: [
          "Agencias gubernamentales",
          "Motores de búsqueda",
          "Medios de comunicación",
          "Los distribuidores de directorios en línea, cuando nos incluyan en el directorio, pueden enlazar a nuestro sitio web de la misma manera que enlazan a los sitios web de otros negocios listados, y",
          "Negocios acreditados a nivel del sistema, excepto las organizaciones sin fines de lucro que hacen solicitudes, centros comerciales benéficos y grupos de recaudación de fondos benéficos, que no pueden enlazar a nuestro sito web."
        ],
        description: {
          "1":
            "Estas organizaciones pueden enlazar a nuestra página principal, a publicaciones o a otra información del sitio web siempre que el enlace: (a) no sea engañoso de ninguna manera; (b) no implique falsamente patrocinio, respaldo o aprobación de la parte que enlaza ni de sus productos o servicios; y (c) esté dentro del contexto del sitio de la parte que enlaza.",
          "2":
            "Podemos considerar y aprobar, a nuestra sola discreción, otras solicitudes de enlaces de diferentes tipos de organizaciones. Aprobaremos las solicitudes de enlace si determinamos que: (a) el enlace no nos perjudicaría ni a nuestros negocios acreditados (por ejemplo, no se permitirán enlaces de asociaciones comerciales u otras organizaciones que representen tipos de negocios dudosos, como oportunidades de trabajo desde casa; (b) la organización no tiene un historial insatisfactorio con nosotros; (c) el beneficio para nosotros por la visibilidad que aporta el enlace supera cualquier falta; y (d) el enlace está dentro del contexto de información general o es consistente con el contenido editorial en un boletín u otro producto similar que promueva la misión de la organización.",
          "3":
            "Si usted forma parte de una de las organizaciones mencionadas anteriormente y está interesado en enlazar a nuestro sitio web, debe notificarnos enviando un correo electrónico a admin@drughelp.care. Por favor, incluya la siguiente información en su mensaje: Su nombre completo, el nombre de su organización, Información de contacto (como número de teléfono y/o dirección de correo electrónico), el URL de su sitio web, una lista de las URL desde las cuales desea enlazar a nuestro sitio web, una lista de las URL o URL (s) a las que desea enlazar. \nPor favor, permita de 2 a 3 semanas para recibir una respuesta."
        },
        approvedorganizationsmayhyperlinktoourwebsiteasfollows: {
          title:
            "Organizaciones aprobadas pueden incluir un hipervínculo a nuestro sitio web de la siguiente manera",
          bullets: [
            "Mediante el uso de nuestro nombre corporativo; o",
            "Mediante el uso del localizador uniforme de recursos (URL) al que se está vinculando; o",
            "Mediante el uso de cualquier otra descripción de nuestro sitio web o del material al que se hace referencia, siempre que tenga sentido dentro del contexto y el formato del contenido del sitio del tercero que enlaza."
          ]
        },
        nouseoflogo:
          "No se permitirá el uso del logotipo de drughelp.care ni de cualquier otro material gráfico con fines de enlace sin un acuerdo de licencia de marca registrada."
      },
      cookies2: {
        title: "Este sitio web utiliza cookies",
        description:
          "Las cookies se utilizan para distinguir entre los usuarios de este sitio web. Esta es una práctica estándar entre los sitios web en Internet. Las cookies pueden tener identificadores únicos y almacenarse en su computadora, dispositivo móvil, en los correos electrónicos que le enviamos, en nuestra páginas web u otros lugares. Este sitio web utiliza cookies para guardar información sobre su uso del sitio, incluyendo su historial de filtros de búsqueda, opciones de ordenamiento o términos que utiliza para buscar en nuestro sitio web."
      },
        "reservationofrights": {
            "title": "Reserva de Derechos",
            "description": "Nos reservamos el derecho, en cualquier momento y a nuestra entera discreción, de solicitar que elimine todos los enlaces o cualquier enlace específico a nuestro sito web. Usted acepta eliminar de inmediato todos los enlaces a nuestro sitio web ante dicha solicitud. También nos reservamos el derecho de modificar estos términos y condiciones, así como nuestra política de enlaces, en cualquier momento. Al continuar enlazando a nuestro sitio web, usted acepta estar sujeto a estos términos y condiciones de enlace y cumplir con ellos."
        },
        "removaloflinksfromourwebsite": {
            "title": "Eliminación de enlaces de nuestro sitio web",
            "description": "Si encuentra algún enlace en nuestro sitio web o en cualquier sitio web vinculado que considere objetable por cualquier motivo, puede comunicarse con nosotros al respecto. Consideraremos las solicitudes para eliminar enlaces, pero no tenemos la obligación de hacerlo ni de responderle directamente. Aunque nos esforzamos por garantizar que la información en este sitio web sea correcta, no garantizamos su integridad o exactitud; tampoco nos comprometemos a asegurar que el sitio web permanezca disponible o que el material publicado esté actualizado."
        },
        "contentliability": {
            "title": "Responsabilidad sobra el contenido",
            "description": "No asumimos ninguna responsabilidad por el contenido que aparezca en su sitio web. Usted acepta indemnizarnos y defendernos ante cualquier reclamación que surja de su sitio web o se base en él. Ningún enlace puede aparecer en ninguna página de su sitio web ni en ningún contexto que contenga contenido o materiales que puedan interpretarse como difamatorios, obscenos o criminales, o que infrinjan, violen o promuevan la infracción u otra violación de los derechos de terceros."
        },
        "disclaimer": {
            "title": "Descargo de responsabilidad",
            "description": [
                "En la máxima medida permitida por la ley aplicable, excluimos todas las representaciones, garantías y condiciones relacionadas con nuestro sitio web y el uso del mismo ( incluyendo, sin limitación, cualquier garantía implícita por ley en cuanto a calidad satisfactoria, idoneidad para un propósito específico y/o el uso de cuidado y habilidad razonables). Nada en este descargo de responsabilidad",
                "Las limitaciones y exclusiones de responsabilidad establecidas en esta sección y en otras partes de este descargo de responsabilidad: (a) están sujetas al párrafo anterior; y ( b) rigen todas las responsabilidades que surjan en virtud de este descargo de responsabilidad o en relación con el objecto del mismo, incluidas las responsabilidades que surjan por contrato, por hechos ilícitos (incluida la negligencia) y por incumplimiento de deberes legales. En medida en que el sitio web y la información y los servicios en el sitio web se proporcionen de forma gratuita, no seremos responsables por ninguna pérdida o daño de cualquier naturaleza."
            ],
            "bullets": [
                "Limitar o excluir nuestra responsabilidad o la suya por muerte o lesiones personales resultantes de negligencia;",
                "limitar o excluir nuestra responsabilidad o la suya por fraude o tergiversación fraudulenta;",
                "limitar cualquiera de nuestras responsabilidades o las suyas de manera no permitida por la legislación aplicable; o",
                "excluir cualquier responsabilidad nuestra o suya que no pueda ser excluida según la ley aplicable."
            ]
        },
      credit: {
        title: "Crédito",
        description:
          "Esta página de Términos y Condiciones fue creada con la ayuda de un generador de la página web termsandconditionstemplate.com."
      },
      contact: {
        title: "Contacto",
        description:
          "Si tienes alguna pregunta sobre nuestros términos, por favor <a href='mailto:admin@drughelp.care'>contáctanos a</a>"
      }
    }
  }
};
export default data;
